module.exports = __webpack_public_path__ + "img/15.15f4ed70.jpg";